<div class="mile-calc-container">
  <xpo-card>
    <xpo-card-header>
      <xpo-card-title class="mile-calc-title">Mile Calculator</xpo-card-title>
    </xpo-card-header>
    <xpo-card-content>
      <div class="mile-calc-content-parent">
        <div class="col-6">
          <app-location
            title="Origin"
            [formGroup]="originForm"
            [displayZipOnly]="displayZipOnly"
            [displayStateCity]="displayStateCity"
          ></app-location>
        </div>
        <div class="col-6">
          <app-location
            title="Destination"
            [formGroup]="destinationForm"
            [displayZipOnly]="displayZipOnly"
            [displayStateCity]="displayStateCity"
          ></app-location>
        </div>
      </div>
    </xpo-card-content>
    <xpo-card-footer>
      <div class="col-6"></div>
      <div class="col-6">
        <xpo-card-actions>
          <form [formGroup]="routeForm" class="routeForm">
            <mat-form-field floatLabel="always">
              <mat-label>Route type</mat-label>
              <mat-select formControlName="routeType" required placeholder="Select a Route Type">
                <mat-option *ngFor="let type of routeTypes" [value]="type.value">
                  {{ type.display }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </form>
          <button
            mat-flat-button
            [disabled]="!originForm.valid || !destinationForm.valid"
            (click)="calculateDistance()"
            class="calculateBtn"
          >
            Calculate
          </button>
          <button
            mat-stroked-button
            (click)="clear()"
            class="clearBtn"
          >
            Clear
          </button>
        </xpo-card-actions>
      </div>
    </xpo-card-footer>
  </xpo-card>
  <ng-container *ngIf="miles >= 0">
    <app-result
      [originZip]="originForm.get('zipCd').value"
      [destinationZip]="destinationForm.get('zipCd').value"
      [miles]="miles"
    ></app-result>
  </ng-container>
</div>
